<template>
  <div class="solution_item">
    <bg-intro :bgIntroData="bgIntroData"></bg-intro>
    <field :fieldData="fieldData"></field>
    <!-- <highlight :highlightsData="highlightData"></highlight> -->
    <brief :briefData="briefData[0]" background="#F6F7F8" :isReverse="true"></brief>
    <brief :briefData="briefData[1]" :isReverse="false"></brief>
    <brief :briefData="briefData[2]" background="#F6F7F8" :isReverse="true"></brief>
    <!-- <product></product> -->
    <div class="form-container">
      <h3>提交您的定制需求</h3>

      <div class="form-content">
        <el-form :model="form" :rules="custom" ref="custom" label-position="top">
          <el-form-item label="定制类型" prop="customType">
            <el-radio-group v-model="form.customType">
              <el-radio label="PHONE_APP">手机APP</el-radio>
              <el-radio label="TABLE_APP">平板APP</el-radio>
              <el-radio label="PC">PC应用</el-radio>
              <el-radio label="BD_AIO_PC">北斗一体机</el-radio>
              <el-radio label="OTHER">其他</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="需求简介" prop="desc">
            <el-input
              type="textarea"
              :autosize="{ minRows: 5 }"
              v-model="form.desc"
              placeholder="请输入您的需求"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系姓名" prop="fullName">
            <el-input v-model="form.fullName" placeholder="请输入联系人姓名"></el-input>
          </el-form-item>
          <el-form-item label="单位名称" prop="companyName">
            <el-input v-model="form.companyName" placeholder="请输入您的单位名称"></el-input>
          </el-form-item>
          <el-form-item label="联络电话" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入您的联系电话"></el-input>
          </el-form-item>
        </el-form>
        <div class="btn-wrapper">
          <button @click="submitCustom">提 交</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bgIntro from '@/components/common/solution/bgIntro.vue';
import field from '@/components/common/solution/field.vue';
import highlight from '@/components/common/solution/highlight.vue';
import brief from '@/components/common/solution/brief.vue';
import product from '@/components/common/solution/product.vue';
import { validatePhone, validateFullName, validateDesc, validateCompany } from '@/utils/validate';
import axios from 'axios';
import config from '../../config';
export default {
  inject: ['reload'],
  metaInfo: {
    title: '企事业单位定制北斗应用',
    meta: [
      {
        name: 'keywords',
        content: '北斗应用开发,北斗短报文开发,北斗系统定制,北斗程序定制,北斗app开发',
      },
      {
        name: 'description',
        content: '多年北斗应用开发经验，无数次迭代优化，版本稳定，所有北斗技术基于成熟应用二次开发，速度快，风险低，价格实在。北斗应用系统更新速度快，不断创新，应用先进。',
      },
    ],
  },
  data() {
    return {
      bgIntroData: {
        bgSrc: require('../../assets/solution/qsy-banner.webp'),
        title: '一站式OEM专属定制',
        intro: '提供一站式智能设备IOS、Android开发服务',
      },
      fieldData: {
        fieldTitle: '服务优势',
        items: [
          {
            id: 'field1',
            imgSrc: require('../../assets/solution/qsy1.webp'),
            intro1: '多年开发经验',
            intro2: '无数次迭代优化，版本稳定',
          },
          {
            id: 'field2',
            imgSrc: require('../../assets/solution/qsy2.webp'),
            intro1: '基于成熟应用二次开发',
            intro2: '速度快，风险低，价格实在',
          },
          {
            id: 'field3',
            imgSrc: require('../../assets/solution/qsy3.webp'),
            intro1: '更新速度快',
            intro2: '不断创新，应用先进',
          },
        ],
      },
      highlightData: {
        title: '方案亮点',
        items: [
          {
            id: 'h1',
            title: '位置上报',
            intro: '在无公网地区用户可用北斗 让公司/家人了解最新动态',
            imgSrc: require('../../assets/solution/fanan.webp'),
          },
          {
            id: 'h2',
            title: '位置上报',
            intro: '在无公网地区用户可用北斗 让公司/家人了解最新动态',
            imgSrc: require('../../assets/solution/fanan.webp'),
          },
          {
            id: 'h3',
            title: '位置上报',
            intro: '在无公网地区用户可用北斗 让公司/家人了解最新动态',
            imgSrc: require('../../assets/solution/fanan.webp'),
          },
          {
            id: 'h4',
            title: '位置上报',
            intro: '在无公网地区用户可用北斗 让公司/家人了解最新动态',
            imgSrc: require('../../assets/solution/fanan.webp'),
          },
        ],
      },
      briefData: [
        {
          title: '北斗车载通信平板应用APP',
          imgSrc: require('../../assets/solution/qsy4.webp'),
          introItems: [
            {
              id: 'intro1',
              subtitle: '平板应用app支持全国卫星/标准离线地图下载，储存在平板电脑本地；  ',
              // intro: '北斗船载终端定时5分钟/次（可调）向后台上报终端位置信息',
            },
            {
              id: 'intro2',
              subtitle: '平板应用app同时支持全蓝牙或串口模式连接北斗车载终端；',
              // intro: '当北斗船载终端收到短报文，APP将会用铃声提醒用户查看短报文',
            },
            {
              id: 'intro3',
              subtitle: '支持更改北斗车载终端的上报频度和上报点数，当用户点击输入报文时候，终端自动停止位置上报；',
              // intro: '船员通过wifi链接北斗船载终端，支持多人同时链接使用',
            },
          ],
        },
        {
          title: '北斗车载通信平板应用APP',
          imgSrc: require('../../assets/solution/qsy5.webp'),
          introItems: [
            {
              id: 'intro1',
              subtitle: '平板应用app支持全国卫星/标准离线地图下载，储存在平板电脑本地；',
              // intro: '北斗船载终端定时5分钟/次（可调）向后台上报终端位置信息',
            },
            {
              id: 'intro2',
              subtitle: '平板应用app同时支持全蓝牙或串口模式连接北斗车载终端；',
              // intro: '当北斗船载终端收到短报文，APP将会用铃声提醒用户查看短报文',
            },
            {
              id: 'intro3',
              subtitle: '支持更改北斗车载终端的上报频度和上报点数，当用户点击输入报文时候，终端自动停止位置上报；',
              // intro: '船员通过wifi链接北斗船载终端，支持多人同时链接使用',
            },
          ],
        },
        {
          title: '北斗户外作业位置监控系统',
          imgSrc: require('../../assets/solution/qsy6.webp'),
          introItems: [
            {
              id: 'intro1',
              subtitle: '平台支持微信、邮件、短信通知，可在无信号区域使用北斗短报文和后台互通；',
              // intro: '北斗船载终端定时5分钟/次（可调）向后台上报终端位置信息',
            },
            {
              id: 'intro2',
              subtitle: '采用BS架构整套系统支持本地专网部署，信息保密安全；',
              // intro: '当北斗船载终端收到短报文，APP将会用铃声提醒用户查看短报文',
            },
            {
              id: 'intro3',
              subtitle:
                '位置监控、轨迹回放、报警处理、平安信息、数据统计、轨迹导出、邮件通知、短信通知、轨迹下发、本地部署、信息存储、报文下发',
              // intro: '船员通过wifi链接北斗船载终端，支持多人同时链接使用',
            },
          ],
        },
      ],
      form: {
        customType: 'PHONE_APP',
        desc: '',
        fullName: '',
        phone: '',
        companyName: '',
      },
      custom: {
        customType: [{ required: true, trigger: 'blur' }],
        desc: [{ required: true, trigger: 'blur', validator: validateDesc }],
        fullName: [{ required: true, trigger: 'blur', validator: validateFullName }],
        companyName: [{ required: true, trigger: 'blur', validator: validateCompany }],
        phone: [{ required: true, trigger: 'blur', validator: validatePhone }],
      },
    };
  },
  methods: {
    submitCustom() {
      this.$refs.custom.validate(async (valid) => {
        if (valid) {
          try {
            const res = await axios({
              baseURL: config.baseUrl,
              url: '/api/console/forms/custom-demand',
              method: 'post',
              params: {
                Authorization: '1213',
                ...this.form,
              },
            });
            console.log(res);
            if (res.data.code === 0) {
              this.$message({
                type: 'success',
                message: '提交成功',
              });
              this.reload();
              // Object.assign(this.$data, this.$options.data());
            }
          } catch (error) {
            console.log(error);
          }
        }
      });
    },
  },
  components: {
    bgIntro,
    field,
    highlight,
    brief,
    product,
  },
};
</script>

<style lang="scss" scoped>
.solution_item {
  width: 100%;
  .form-container {
    h3 {
      text-align: center;
      font-size: 28px;
      font-weight: 400;
      color: #0d0e24;
      margin-top: 50px;
      margin-bottom: 50px;
    }
    width: 1000px;
    margin: 0 auto;
    .form-content {
      width: 800px;
      margin: 0 auto;
      &::v-deep {
        .el-form-item__label {
          font-size: 16px;
          font-weight: bold;
          color: #333333;
        }
      }
      .btn-wrapper {
        text-align: left;
        margin-top: 60px;
        margin-bottom: 60px;
        button {
          width: 256px;
          height: 46px;
          background: #4173fb;
          border-radius: 4px;
          cursor: pointer;
          outline: none;
          border: none;
          font-size: 16px;
          font-weight: 400;
          color: #ffffff;
        }
      }
    }
  }
}
</style>